/* ********** Fonts ********** */
import ligthFont from './fonts/MyriadPro-Light.woff';
import regularFont from './fonts/MyriadPro-Regular.woff';
import boldFont from './fonts/MyriadPro-Bold.woff';


/* ********** Images ********** */
import favicon from './images/favicon.png';
import logo from './images/logo.svg';
import logoHorizont from './images/logo-horizont.svg';
import iconLogin from './images/icon-login.svg';

import slideMovilPersonasAuto from './images/bts-slider-personas-01-movil.jpg';
import slideDesktopPersonasAuto from './images/bts-slider-personas-01.jpg';
import slideMovilPersonasVida from './images/bts-slider-personas-02-movil.jpg';
import slideDesktopPersonasVida from './images/bts-slider-personas-02.jpg';
import slideMovilPersonasAP from './images/bts-slider-personas-03-movil.jpg';
import slideDesktopPersonasAP from './images/bts-slider-personas-03.jpg';
import slideMovilPyme from './images/bts-slider-pymes-01-movil.jpg';
import slideDesktopPyme from './images/bts-slider-pymes-01.jpg';
import slideMovilPymeDanio from './images/bts-slider-pymes-02-movil.jpg';
import slideDesktopPymeDanio from './images/bts-slider-pymes-02.jpg';
import slideMovilPymeGMM from './images/bts-slider-pymes-03-movil.jpg';
import slideDesktopPymeGMM from './images/bts-slider-pymes-03.jpg';
import slideMovilCorporativo from './images/bts-slider-corporativos-01-movil.jpg';
import slideDesktopCorporativo from './images/bts-slider-corporativos-01.jpg';
import slideMovilCorporativoDanio from './images/bts-slider-corporativos-02-movil.jpg';
import slideDesktopCorporativoDanio from './images/bts-slider-corporativos-02.jpg';
import slideMovilCorporativoFlotilla from './images/bts-slider-corporativos-03-movil.jpg';
import slideDesktopCorporativoFlotilla from './images/bts-slider-corporativos-03.jpg';
import slideMovilSindicato from './images/bts-slider-sindicatos-01-movil.jpg';
import slideDesktopSindicato from './images/bts-slider-sindicatos-01.jpg';

import imageProducts from './images/bts-slider-productos.jpg';
import imagePersonas from './images/bts-seguro-personas.jpg';
import imagePymes from './images/bts-seguro-pymes.jpg';
import imageCorporativos from './images/bts-seguro-corporativos.jpg';

import imageSegurosPersonas from './images/bts-slider-seguros-personas.jpg';
import imageSegurosPersonasMovil from './images/bts-slider-seguros-personas-movil.jpg';
import imageSegurosPersonasAuto from './images/bts-slider-seguros-personas-auto.jpg';
import imageSegurosPersonasAutoMovil from './images/bts-slider-seguros-personas-auto-movil.jpg';

import imageSegurosPymes from './images/bts-slider-seguros-pymes.jpg';
import imageSegurosPymesMovil from './images/bts-slider-seguros-pymes-movil.jpg';

import imageSegurosCorporativos from './images/bts-slider-seguros-corporativos.jpg';
import imageSegurosPCorporativosMovil from './images/bts-slider-seguros-corporativos-movil.jpg';

import cdmx from './images/cdmx.svg';

import iconModalMovil from './images/icon-close-movil.svg';
import iconModalDesktop from './images/icon-close-desktop.svg';

import iconAuto from './images/icon-auto.svg';
import iconAP from './images/icon-ap.svg';
import iconHogar from './images/icon-hogar.svg';
import iconSalud from './images/icon-salud.svg';
import iconRc from './images/icon-rc.svg';
import iconDE from './images/icon-daños.svg';
import iconGMM from './images/icon-gmm.svg';
import iconVida from './images/icon-vida.svg';
import iconCancer from './images/icon-cancer.svg';
import iconInfarto from './images/icon-infarto.svg';
import iconPyme from './images/icon-pyme.svg';
import iconCorp from './images/icon-corporativo.svg';

import iconSupport from './images/icon-support.svg';
import iconNotifica from './images/icon-notifica.svg';
import iconPolizaExterna from './images/icon-poliza-externa.svg';
import iconAdministra from './images/icon_administra.svg';
import iconAvisos from './images/icon-avisos.svg';
import iconCotiza from './images/icon-cotiza.svg';
import iconPlataforma from './images/icon-plataforma.svg';
import iconMasivos from './images/icon-seguros-masivos.svg';
import iconPhone from './images/icon-phone.svg';
import iconAnalisis from './images/icon-analisis.svg';
import iconEnlace from './images/icon-enlace.svg';
import iconEstadistica from './images/icon-estadisticas.svg';
import iconCompara from './images/icon-compara.svg';
import iconEmail from './images/icon-email.svg';
import iconExpGMM from './images/icon-gastos-medicos.svg';
import iconExpPoliza from './images/icon-consulta-poliza.svg';
import iconExpEstadistica from './images/icon-estadistica-activos.svg';

import appPolizas from './images/iphone-polizas-bts.png';
import appAuto from './images/iphone-poliza-bts.png';
import appLogIn from './images/iphone-login-bts.png';

import logoGNP from './images/logo-gnp.svg';
import logoQualitas from './images/logo-qualitas.svg';
import logoAxa from './images/logo-axa.svg';
import logoMapfre from './images/logo-mapfre.svg';
import logoSisnova from './images/logo-sisnova.svg';
import logoZurich from './images/logo-zurich.svg';
import logoBanorte from './images/logo-seguros-banorte.svg';
import logoChubb from './images/logo-chubb.svg';
import logoHDI from './images/logo-hdi.svg';
import logoAtlas from './images/logo-seguros-atlas.svg';
import logoAna from './images/logo-ana.svg';
import logoGMX from './images/logo-gmx.svg';
import logoPrimero from './images/logo-primero-seguros.svg';
import logoBupa from './images/logo-bupa.svg';
import logoBx from './images/logo-bx+.svg';
import logoSura from './images/logo-sura.svg';

import slidePlatformSiniestro from './images/macbook__siniestro.png';
import slidePlatformPolizas from './images/macbook__polizas.png';
import slidePlatformPoliza from './images/macbook__poliza.png';
import sliderBack from './images/slider__back.svg';
import sliderNext from './images/slider__next.svg';

import guruCall from './images/guru-call.svg';

import parallaxMiniban from './images/amigos-en-miniban-bajatuseguro.jpg';
import parallaxEmprendedor from './images/emprendedor-bajatuseguro.jpg';
import parallaxExperience from './images/laptop.jpg';

import iconFacebook from './images/social-facebook.svg';
import iconInstagram from './images/social-instagram.svg';
import iconTwitter from './images/social-twitter.svg';
import iconLinkedIn from './images/social-linkedin.svg';
import iconYouTube from './images/social-youtube.svg';
import playStore from './images/play-store.svg';
import appStore from './images/app-store.svg';

import technology from './images/technology.svg';
import guru from './images/guru.svg';

import iconMission from './images/icon-mission.svg';
import iconVision from './images/icon-vision.svg';
import iconValues from './images/icon-values.svg';
import awardGlobal from './images/global-quality-gold-elite-2015-bajatuseguro.png'

import iconCheck from './images/icon-check.svg';
import iconCancel from './images/icon-cancel.svg';

import imgPoligonNosotros from './images/bts-team.jpg'
import imgPoligonContacto from './images/cdmx-angel.jpg'


/* ********** CSS ********** */
import scss from './scss/main.scss';


/* ********** JavaScript ********** */
import { activeMenu, activeMenuLink } from './js/active-menu'
import { cotizadorAutoPersonasHero, cotizadorVidaPersonasHero, cotizadorAPPersonasHero, cotizadorAutoPersonasBody, cotizadorAPPersonasBody, cotizadorHogarPersonasBody, cotizadorSaludPersonasBody, cotizadorRCPersonasBody, cotizadorPymesHero, cotizadorDaniosPymesHero, cotizadorGMMPymesHero, cotizadorAutoPymesBody, cotizadorDaniosPymesBody, cotizadorHogarPymesBody, cotizadorGMMPymesBody, cotizadorVidaPymesBody, cotizadorEmpresasHero, cotizadorDaniosCorporativosHero, cotizadorFlotillaCorporativosHero, cotizadorAutoCorporativosBody, cotizadorDaniosCorporativosBody, cotizadorHogarCorporativosBody, cotizadorGMMCorporativosBody, cotizadorVidaCorporativosBody, cotizadorAuto } from './js/modal'
import { validarLoginForm, validarRecuperarForm, validarSigninForm, validarLlamameForm, validarCotizadorSindicatos, enviarSeguroCorreo } from './js/validaciones';

activeMenu();
activeMenuLink();

// Cotizadores Sección index
cotizadorAutoPersonasHero();
cotizadorVidaPersonasHero();
cotizadorAPPersonasHero();
cotizadorAutoPersonasBody();
cotizadorAPPersonasBody();
cotizadorHogarPersonasBody();
cotizadorSaludPersonasBody();
cotizadorRCPersonasBody();

// Cotizadores Sección Pymes
cotizadorPymesHero();
cotizadorDaniosPymesHero();
cotizadorGMMPymesHero();
cotizadorAutoPymesBody();
cotizadorDaniosPymesBody();
cotizadorHogarPymesBody();
cotizadorGMMPymesBody();
cotizadorVidaPymesBody();

// Cotizadores Sección Cosporativos
cotizadorEmpresasHero();
cotizadorDaniosCorporativosHero();
cotizadorFlotillaCorporativosHero();
cotizadorAutoCorporativosBody();
cotizadorDaniosCorporativosBody();
cotizadorHogarCorporativosBody();
cotizadorGMMCorporativosBody();
cotizadorVidaCorporativosBody();

// Cotizadores Sección Auto
cotizadorAuto();


// Sweet Alert
let callMe = document.getElementById('validarLlamameForm');
let sindicatos = document.getElementById('validarCotizadorSindicatos');
let login = document.getElementById('validarLoginForm');
let signin = document.getElementById('validarSigninForm');
let recuperar = document.getElementById('validarRecuperarForm');
let enviar = document.querySelector('#enviarSeguroCorreo');
let loQuiero = document.querySelector('.lo-quiero');

if (callMe) {
  callMe.addEventListener('click', () => { validarLlamameForm(); });
} else if (sindicatos) {
  sindicatos.addEventListener('click', () => { validarCotizadorSindicatos(); });
} else if(login){
  login.addEventListener('click', () => { validarLoginForm(); });
} else if (signin) {
  signin.addEventListener('click', () => { validarSigninForm(); });
} else if (recuperar) {
  recuperar.addEventListener('click', () => { validarRecuperarForm(); });
} else if (enviar) {
  enviar.addEventListener('click', () => { enviarSeguroCorreo(); });
} else if (loQuiero) {
  loQuiero.addEventListener('click', () => { enviarSeguroCorreo(); });
}


/**** Preloader ****/

let preloader = document.getElementById('preloader');

if (preloader) {
  window.onload = function() {
    var loader = document.getElementById('preloader');
    setTimeout(function(){
      loader.style.visibility = 'hidden';
      loader.style.display = 'none';
    }, 3000);
  }
}
